import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { agency } from "../api";

export default function AgencyAlerts() {
  const [alerts, setAlerts] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    agency.alerts().then(setAlerts).catch((e) => setErr(e.message));
  }, []);

  if (err) return <div className="page"><div className="error-box">{err}</div></div>;
  if (!alerts) return <div className="page"><p className="subtle">Loading…</p></div>;

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Alerts</h1>
          <div className="subtle">Cross-client anomalies surfaced by the last narrative run.</div>
        </div>
      </div>
      {alerts.length === 0 ? (
        <div className="empty">No open alerts across your portfolio.</div>
      ) : (
        <div>
          {alerts.map((a) => (
            <div className="reco" key={a.id}>
              <h4>{a.title}</h4>
              <div className="meta">
                <span className={`tag ${a.severity}`}>{a.severity}</span>
                <Link to={`/clients/${a.client_id}`} className="tag">{a.client_name}</Link>
                <span className="tag">{new Date(a.detected_at).toLocaleDateString()}</span>
              </div>
              {a.description && <div className="body">{a.description}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
